import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useRef, useEffect } from 'react'
//import { useState, useEffect, useRef } from 'react'
import About from '../views/about';
import Home from '../views/home';
import Test from '../views/test';
import ScrollerSlides from '../views/twenty';
import Note from '../views/note'
import Five from '../views/five'
import Ten from '../views/ten'
import Twenty from '../views/twenty'
import Fifty from '../views/fifty'
import Hundred from '../views/hundred'
import { GA_ID } from '../constants';
// import {AnimationLayout} from '../components/AnimationLayout'
//import {  useLocation, useParams, useNavigate } from "react-router-dom";

//https://stackoverflow.com/questions/61089053/animating-route-transitions-with-csstransitiongroup-and-react-router-v6
//https://codesandbox.io/s/react-router-animation-working-fix-9j415?fontsize=14&hidenavigation=1&theme=dark&file=/src/App.js:121-194
import { TransitionGroup, CSSTransition } from "react-transition-group";

// import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'

// https://www.geeksforgeeks.org/reactjs-router/
//https://handsonreact.com/docs/labs/js/21a-RouterTransitions
const DisplayRoute = () => {
  const location = useLocation();
  //console.log("DisplayRoute", location)
  const nodeRef = useRef(null);

  // location changed event: google analytics pageview tracking goes here
  useEffect(() => {
    console.log("DisplayRoute... changed", location)

    //ReactGA.pageview(location); //window.location.pathname + window.location.search);
    const tagManagerArgs = {
      gtmId: GA_ID,
      dataLayer: { page: location },
      events: { 'gtm.start':new Date().getTime(), event:'gtm.js' }
    }
    console.log("* TagManager TRACK", tagManagerArgs)
    TagManager.dataLayer(tagManagerArgs)
  }, [location]);

  return (
    <div className="container h-full">
    <TransitionGroup>
    <CSSTransition key={location.key} classNames="fadeit" timeout={500}>
    <Routes location={location} basename="/#" basename_notworking={process.env.PUBLIC_URL} >
      {/* <Route element={<AnimationLayout />}> */}
        <Route exact path='/' element={< Home />}></Route>
        <Route path='/:slideId' element={< Home />}></Route>
        {/* <Route exact path='/intro' element={< Home />}></Route> */}
        {/* <Route exact path='/about' element={< About />}></Route> */}
        <Route exact path='/five' element={< Five />} ></Route>
        <Route path='/five:slideId' element={< Five />}></Route>
        <Route exact path='/ten' element={< Ten />}></Route>
        <Route path='/ten:slideId' element={< Ten />}></Route>
        <Route exact path='/twenty' element={< Twenty />}></Route>
        <Route path='/twenty:slideId' element={< Twenty />}></Route>
        <Route exact path='/fifty' element={< Fifty />}></Route>
        <Route path='/fifty:slideId' element={< Fifty />}></Route>
        <Route exact path='/hundred' element={< Hundred />}></Route>
        <Route path='/hundred:slideId' element={< Hundred />}></Route>
        {/* <Route exact path='/test' element={< Test />}></Route> */}
        {/* <Route exact path='/note' element={< Note />}></Route> */}
        {/* <Route exact path='/ten' element={< Ten />}></Route> */}
      {/* </Route> */}
    </Routes>
    </CSSTransition>
    </TransitionGroup>
    </div>
  )
};

export { DisplayRoute };


// <Routes>
// <Route path='/'>
//   <About />
// </Route>
// {/* <Route exact path='/map'>
//   <Map />
// </Route>
// <Route exact path='/trials'>
//   <Trials />
// </Route>
// <Route exact path='/discover'>
//   <Discover />
// </Route>
// <Route exact path='/education'>
//   <Education />
// </Route>
// <Route exact path='/courthouse'>
//   <Courthouse />
// </Route> */}
// <Route path='/about'>
//   <About />
// </Route>
// </Routes>